import Icon from './Icon';
import PropTypes from 'prop-types';
import cn from 'classnames';

export default function InputWithIcon({
                                          icon,
                                          children,
                                          className,
                                          width
                                      }: any) {
    return (
        <div className={cn('input-with-icon', className)} style={{width}}>
            <span className="input-left-icon"><Icon name={icon}/></span>
            {children}
        </div>
    )
}

InputWithIcon.propTypes = {
    icon: PropTypes.string.isRequired,
}
